<template>
  <div class="list">Admin list</div>
</template>

<script>
export default {
  name: "administratorList",
};
</script>

<style scoped></style>
